import React from 'react';

export default function DocumentsPanel({
  documents,
  documentsStatus,
  onDocumentUpload,
  onPrintDocument,
  onDeleteDocument,
  formatDate,
}) {
  const documentRows = Array.isArray(documents) ? documents : [];

  return (
    <section id="admin-documents">
      <h3
        style={{
          color: '#b6eaff',
          fontSize: '1.3rem',
          marginBottom: '1rem',
        }}
      >
        DOCUMENTS
      </h3>

      <div
        style={{
          background: '#23243a',
          border: '1px solid #2f466d',
          borderRadius: 10,
          padding: '1rem',
        }}
      >
        <label
          style={{
            display: 'inline-block',
            marginBottom: 10,
            color: '#b6eaff',
          }}
        >
          <span
            style={{
              marginRight: 10,
              fontWeight: 700,
              fontSize: '1rem',
              color: '#d7ebff',
            }}
          >
            Upload document
          </span>

          <input
            type="file"
            onChange={onDocumentUpload}
            style={{ color: '#b6eaff' }}
          />
        </label>

        {documentsStatus && (
          <div style={{ color: '#1ecfff', marginBottom: 10 }}>
            {documentsStatus}
          </div>
        )}

        {documentRows.length === 0 ? (
          <div
            style={{
              color: '#8db7e6',
              marginTop: 10,
              fontSize: '0.85rem',
              opacity: 0.8,
            }}
          >
            No club documents uploaded
          </div>
        ) : (
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
            }}
          >
            {documentRows.map((document) => (
              <li
                key={document.id}
                style={{
                  background: '#1a2338',
                  border: '1px solid #35507f',
                  borderRadius: 8,
                  padding: '0.8rem',
                  marginBottom: 8,
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: 10,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <div style={{ color: '#d7ebff' }}>
                  <div style={{ fontWeight: 700 }}>
                    {document.name}
                  </div>

                  <div
                    style={{
                      color: '#8db7e6',
                      fontSize: '0.9rem',
                    }}
                  >
                    {formatDate(document.uploadedAt)}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    gap: 8,
                    flexWrap: 'wrap',
                  }}
                >
                  <a
                    href={document.dataUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: 'none',
                      background: '#9ed0ff',
                      color: '#10233a',
                      borderRadius: 8,
                      padding: '0.45rem 0.8rem',
                      fontWeight: 700,
                    }}
                  >
                    OPEN
                  </a>

                  <a
                    href={document.dataUrl}
                    download={document.name}
                    style={{
                      textDecoration: 'none',
                      background: '#1ecfff',
                      color: '#090a12',
                      borderRadius: 8,
                      padding: '0.45rem 0.8rem',
                      fontWeight: 700,
                    }}
                  >
                    DOWNLOAD
                  </a>

                  <button
                    type="button"
                    onClick={() => onPrintDocument(document)}
                    style={{
                      background: '#ffd27a',
                      color: '#2e1a00',
                      border: 'none',
                      borderRadius: 8,
                      padding: '0.45rem 0.8rem',
                      fontWeight: 700,
                      cursor: 'pointer',
                    }}
                  >
                    PRINT
                  </button>

                  <button
                    type="button"
                    onClick={() => onDeleteDocument(document.id)}
                    style={{
                      background: '#ff7c7c',
                      color: '#290707',
                      border: 'none',
                      borderRadius: 8,
                      padding: '0.45rem 0.8rem',
                      fontWeight: 700,
                      cursor: 'pointer',
                    }}
                  >
                    DELETE
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}